import moment from "moment-timezone";

export function setCorrectDateToLunchHour(startDate, endDate, lunchDate) {
  if (moment(startDate).format("HH:mm") < moment(lunchDate).format("HH:mm")) {
    return moment(
      moment(startDate).format("YYYY/MM/DD")
      + ' ' +
      moment(lunchDate).format("HH:mm"),
      "YYYY/MM/DD HH:mm",
      true
    ).toDate()
  }

  return moment(
    moment(endDate).format("YYYY/MM/DD")
    + ' ' +
    moment(lunchDate).format("HH:mm"),
    "YYYY/MM/DD HH:mm",
    true
  ).toDate();
}

export const combineDateTime = (date, time) => {
  const dateMoment = moment(date);

  if (!dateMoment.isValid()) return null;

  const timeMoment = moment(time);

  // Ne pas analyser ici une chaîne de date concaténée. Safari rejette les valeurs
  // telles que "2026-08-28 " lorsque l’heure est vide, contrairement à Chromium.
  if (!time || !timeMoment.isValid()) {
    return dateMoment.startOf("day").toDate();
  }

  return dateMoment
    .hour(timeMoment.hour())
    .minute(timeMoment.minute())
    .second(0)
    .millisecond(0)
    .toDate();
};
